import './CaseStudyFilter.scss'

import React, { FunctionComponent } from 'react'
import Select, { components, IndicatorProps } from 'react-select'
import PuxIcon from 'Shared/components/PuxIcon/PuxIcon'
import { dt } from 'Shared/utils/dynamicRS'
import { t } from 'ttag'

import {
  FilterInputType,
  getDataByKey,
  getLocalizedSelectValue,
  SelectOptionType,
} from '../PuxRepeater'

const rootClass = `partner-filter`

const DropdownIndicator: FunctionComponent<
  IndicatorProps<SelectOptionType, false>
> = (props) => (
  <components.DropdownIndicator {...props}>
    <PuxIcon
      name={
        props.selectProps.menuIsOpen ? `arrows/up-arrow` : `arrows/down-arrow`
      }
      size={16}
      decorative
    />
  </components.DropdownIndicator>
)

const getSelectClassName = (value?: string) =>
  `react-select-container${value ? ` is-filled` : ``}`

const PartnerFilter: FunctionComponent<FilterInputType> = (props) => {
  const data = props.completeData

  const rsSolution = dt(`Pux.RepeaterFilter.Partner.Country`)
  const rsLevel = dt(`Pux.RepeaterFilter.Partner.Level`)

  const countryData = getDataByKey(data, `partnerCountry`, rsSolution)
  const levelData = getDataByKey(data, `partnerLevel`, rsLevel)

  props.setBindingTable({
    'filter-country': {
      field: `partnerCountry`,
    },
    'filter-level': {
      field: `partnerLevel`,
    },
  })

  return (
    <div className={`pux-repeater-filter ${rootClass}-wrapper`}>
      <div className={`pux-repeater-filter-item`}>
        <label htmlFor='filter-country'>
          {t`Pux.RepeaterFilter.Partner.Country.Label`}
        </label>
        <Select
          inputId='filter-country'
          name='filter-country'
          className={getSelectClassName(props.activeFilters[`partnerCountry`])}
          classNamePrefix='react-select'
          components={{ DropdownIndicator }}
          value={getLocalizedSelectValue(
            props.activeFilters[`partnerCountry`],
            `Pux.RepeaterFilter.Partner.Country`
          )}
          options={countryData}
          onChange={(selectedOption) =>
            props.updateUrl(
              selectedOption ? selectedOption.value : ``,
              `filter-country`
            )
          }
        />
      </div>
      <div className={`pux-repeater-filter-item`}>
        <label htmlFor='filter-level'>
          {t`Pux.RepeaterFilter.Partner.Level.Label`}
        </label>
        <Select
          inputId='filter-level'
          name='filter-level'
          className={getSelectClassName(props.activeFilters[`partnerLevel`])}
          classNamePrefix='react-select'
          components={{ DropdownIndicator }}
          value={getLocalizedSelectValue(
            props.activeFilters[`partnerLevel`],
            `Pux.RepeaterFilter.Partner.Level`
          )}
          options={levelData}
          onChange={(selectedOption) =>
            props.updateUrl(
              selectedOption ? selectedOption.value : ``,
              `filter-level`
            )
          }
        />
      </div>
      <div
        className={`pux-repeater-filter-item pux-repeater-filter-item--clear`}
      >
        <button
          type='button'
          className='clear-button'
          onClick={props.clearFilter}
        >
          <span className='clear-button-text'>{t`Pux.RepeaterFilter.ClearAll`}</span>
          <PuxIcon name='arrows/refresh' size={24} decorative />
        </button>
      </div>
    </div>
  )
}

export default PartnerFilter
